import { Col, Alert } from 'reactstrap';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { Modal } from 'antd';
// import { Helmet } from "react-helmet";
// Local Deps
import msgs from '../../../config/messages';
import Loading from '../../Loading';
import UserForm from '../../forms/UserForm';
import EditUserHOC from './EditUserHOC';
import './EditUser.scss';

class EditUser extends Component {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    onChangeRole: PropTypes.func.isRequired,
    onChangeField: PropTypes.func.isRequired,
    initialValues: PropTypes.shape({
      id: PropTypes.string,
      fullName: PropTypes.string,
      email: PropTypes.string,
      phoneNumber: PropTypes.string,
      faxNumber: PropTypes.string,
      iconStatus: PropTypes.string,
      role: PropTypes.string,
    }).isRequired,
    auth: PropTypes.shape({
      jwtToken: PropTypes.string,
      expiration: PropTypes.number,
      organizationId: PropTypes.string,
    }).isRequired,
    isLoading: PropTypes.bool,
    // showConfirmation: PropTypes.bool.isRequired,
    alertType: PropTypes.string.isRequired,
    alertMessage: PropTypes.string.isRequired,
    showEditModal: PropTypes.bool.isRequired,
    closeEditModal: PropTypes.func.isRequired,
  };

  static defaultProps = {
    isLoading: false,
  };

  static _validateValues(values) {
    const errors = {};

    if (!values.role) {
      errors.role = `${msgs.form.required}`;
    }
    return errors;
  }

  render() {
    const {
      onSubmit,
      onChangeRole,
      onChangeField,
      initialValues,
      auth,
      isLoading,
      // showConfirmation,
      alertType,
      alertMessage,
      closeEditModal,
      showEditModal,
    } = this.props;
    return (
      <div className="nf-edit-user">
        {/* <Helmet>
          <meta charSet="utf-8" />
          <title>NFFS ICON - Edit User Page</title>
        </Helmet> */}
        <Modal
          title={<h3>{msgs.EditUser.header}</h3>}
          visible={showEditModal}
          width="fit-content"
          footer={null}
          onCancel={closeEditModal}
        >
          <Col style={{ display: 'flex', justifyContent: 'center' }}>
            {alertMessage && <Alert color={alertType}>{alertMessage}</Alert>}
          </Col>
          {/* <Col
            className="nf-edit-user__subheader"
            md="col-md-6 col-md-offset-3"
          >
            <h4>{msgs.EditUser.requiredFields}</h4>
          </Col> */}
          {isLoading ? (
            <Loading text={msgs.EditUser.pageisLoading} />
          ) : (
            <UserForm
              onSubmit={onSubmit}
              onChangeRole={onChangeRole}
              onChangeField={onChangeField}
              initialValues={initialValues}
              validateValues={EditUser._validateValues}
              auth={auth}
              onCancelUserForm={closeEditModal}
            />
          )}
        </Modal>
      </div>
    );
  }
}

export default EditUserHOC(EditUser);



// WEBPACK FOOTER //
// ./src/components/Modals/EditUser/EditUser.jsx